import React from 'react';
import { EntityForm } from '../../widgets/Forms';
import { CustomTextField } from '../../widgets/CustomTextField';

export default function WorkplaceSearchForm(props) {
        return (
            <EntityForm ref={React.createRef()} viewId="workplace" values={props.data}
                entityLookupController={props.entityLookupController} org="saseta"
                entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
                {form =>
                    <form className={form.classes.container} id="WorkplaceSearchForm">
                        <div className="row search-form-container">
                            <div className="col form-col">
                                <CustomTextField
                                    id="CompanyName"
                                    label="Company Name"
                                    className="w-100"
                                    onKeyPress={props.onKeyUp}
                                    InputProps={{
                                        readOnly: false,
                                    }}
                                    form={form}
                                />
                            </div>
                        </div>
                    </form>
                }
            </EntityForm >
        );
    }